/**
 * Configuración centralizada de la API
 * 
 * Esta configuración asegura que todas las peticiones usen la URL correcta
 * definida en REACT_APP_API_URL. Si no está definida, usa un fallback seguro.
 */

// Obtener la URL de la API desde variables de entorno
// En producción, Railway debe tener REACT_APP_API_URL configurada
const getApiUrl = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  
  if (!apiUrl) {
    return 'http://127.0.0.1:8003';
  }
  
  // Asegurar que la URL termine con / si no termina
  return apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl;
};

export const API_URL = getApiUrl();

export default API_URL;
